type Props = { name: string; size?: number; className?: string };

export function Avatar({ name, size = 32, className }: Props): React.JSX.Element {
  const words = name.trim().split(/\s+/);
  const initials = words
    .slice(0, 2)
    .map((w) => w[0] ?? "")
    .join("")
    .toUpperCase();
  const hue = (name.charCodeAt(0) * 37 + (name.charCodeAt(1) ?? 0) * 13) % 360;

  return (
    <div
      className={`shrink-0 flex items-center justify-center rounded-full font-display font-bold text-white select-none ${className ?? ""}`}
      style={{
        width: size,
        height: size,
        background: `oklch(0.55 0.12 ${hue})`,
        fontSize: Math.round(size * 0.38),
      }}
      aria-hidden="true"
    >
      {initials}
    </div>
  );
}
